import { render, staticRenderFns } from "./AddProjectCompany.vue?vue&type=template&id=7455ccf8&scoped=true"
import script from "./AddProjectCompany.vue?vue&type=script&lang=js"
export * from "./AddProjectCompany.vue?vue&type=script&lang=js"
import style0 from "./AddProjectCompany.vue?vue&type=style&index=0&id=7455ccf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7455ccf8",
  null
  
)

export default component.exports